export default "__VITE_ASSET__jtSuN2$X__"